"use strict";

new WOW().init();

(function ($) {
  $(document).ready(function () {
    // HEADER-BURGER ========================================================================================================================================================
    $('.header__burger').on('click', function () {
      $(this).toggleClass("active");
      $('header').toggleClass('header_mobile');
      $('body').toggleClass('open');
    });
    $('.overlay').on('click', function () {
      if ($('header').hasClass('header_mobile')) {
        $('header').removeClass('header_mobile');
        $('body').removeClass('open');
      }
    }); // HEADER-SCROLL ========================================================================================================================================================

    var scrollChange = 5;

    function headerScroll(params) {
      var scroll = $(window).scrollTop();

      if (scroll >= scrollChange) {
        $('.header').addClass('header_scroll');
      } else {
        $('.header').removeClass('header_scroll');
      }
    }

    $(document).on('scroll', function () {
      headerScroll();
    });
    headerScroll(); // GET YEAR ========================================================================================================================================================

    if (document.querySelectorAll('.year').length > 0) {
      var yearSpan = document.querySelector('.year');
      var date = new Date();
      var yearFull = date.getFullYear();
      yearSpan.innerHTML = yearFull;
    } //HERO SLIDER ======================================================================================================================================================


    if ($(".hero__slider").length > 0) {
      var heroSlider = new Swiper('.hero__slider', {
        slidesPerView: 1,
        speed: 1000,
        spaceBetween: 0,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          el: ".pagination-hero-slider",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      });
    } //SELECT 2 ==============================================================================================================================================


    $('.js-example-basic-single').each(function () {
      $(this).select2();
    }); //SCROLL TO SECTION =======================================================================================================================================

    $('.btn-scroll').click(function (event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top - 60
      }, 1000);
      return false;
    }); //DATAPICKER ===========================================================================================================================

    $.datepicker.regional['uk'] = {
      closeText: 'Закрити',
      prevText: '&#x3C;Попередній',
      nextText: 'Наступний&#x3E;',
      currentText: 'Сьогодні',
      monthNames: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
      monthNamesShort: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
      dayNames: ['неділя', 'понеділок', 'вівторок', 'середа', 'четвер', 'п\'ятниця', 'субота'],
      dayNamesShort: ['нед', 'пнд', 'вів', 'срд', 'чтв', 'птн', 'сбт'],
      dayNamesMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      weekHeader: 'Тиж',
      dateFormat: 'dd.mm.yy',
      firstDay: 1,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: ''
    };
    $.datepicker.setDefaults($.datepicker.regional['uk']);
    $("#birthday").datepicker({
      changeMonth: true,
      changeYear: true,
      yearRange: "1900:2024",
      maxDate: new Date(),
      showAnim: "slideDown"
    }); //SECTION SCROLL=================================================================================================================================================

    if ($(".section__scroll-image").length > 0) {
      var controller = new ScrollMagic.Controller();
      $(".background-image").each(function () {
        var image = this;
        var isScrolled = false;
        var scrollPercentage = 0;
        gsap.set(image, {
          scaleX: 0.92,
          scaleY: 0.92,
          transformOrigin: 'center center'
        });
        var scene = new ScrollMagic.Scene({
          triggerElement: image,
          triggerHook: 'onEnter',
          duration: '80%'
        }).addTo(controller).on('progress', function (event) {
          var progress = event.progress;
          var direction = progress > scrollPercentage ? 'FORWARD' : 'REVERSE';
          isScrolled = true;
          scrollPercentage = progress;

          if (direction === 'FORWARD') {
            var scale = 0.92 + 0.08 * progress;
            gsap.to(image, {
              scaleX: scale,
              scaleY: scale,
              duration: 0.8
            });
          } else {
            if (isScrolled && progress > 0.7) {
              gsap.to(image, {
                scaleX: 0.92,
                scaleY: 0.92,
                duration: 0.8
              });
            }
          }
        });
      });
    }
  });
})(jQuery);